import * as React from "react";
const SvgFiRrShowerDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-shower-down_svg__a)">
      <path
        fill="#062147"
        d="M23.358 7.895C22.164 6.597 18.055 2.541 13 2.05V1.001a1 1 0 0 0-2 0V2.05C5.945 2.541 1.836 6.596.642 7.895A2.44 2.44 0 0 0 0 9.549C0 10.9 1.1 12 2.451 12H21.55a2.454 2.454 0 0 0 1.809-4.106zM21.549 10H2.451a.451.451 0 0 1-.337-.751C3.247 8.018 7.307 4 12 4s8.753 4.018 9.886 5.249a.451.451 0 0 1-.337.752zm-8.12 10.586a2 2 0 1 1-2.828 0l.803-.9a.82.82 0 0 1 1.223 0zm5.985 0a2 2 0 1 1-2.828 0l.803-.9a.82.82 0 0 1 1.223 0zm-12 0a2 2 0 1 1-2.828 0l.803-.9a.82.82 0 0 1 1.223 0zm3.029-3.172A2 2 0 0 1 9.029 18a2 2 0 0 1-1.414-3.414l.803-.9a.82.82 0 0 1 1.223 0l.803.9a2 2 0 0 1 0 2.828zm5.985 0a2 2 0 0 1-1.414.586 2 2 0 0 1-1.414-3.414l.803-.9a.82.82 0 0 1 1.223 0l.803.9a2 2 0 0 1 0 2.828z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-shower-down_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrShowerDown;
